import { render } from "./pseudo-class-variants.md?vue&type=template&id=25774c9e"
const script = {}
script.render = render

export default script